import _getIterator from '/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-runtime/core-js/get-iterator';
import _regeneratorRuntime from '/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-runtime/helpers/asyncToGenerator';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import API from '~/api/api.js';
import grantchart from '~/components/grantchartQU.vue';
import upload from '~/components/upload.vue';
import isButton from '~/components/button.vue';
var miniToastr = void 0;
var Datepicker = void 0;
if (process.browser) {
  miniToastr = require('mini-toastr');
  Datepicker = require('vuejs-datepicker');
}
// const reloadData = id => {
//   return API.listTaskOfProject(id)
// }
export default {
  middleware: ['auth', 'authorizeAdminAndEngineer'],
  mounted: function mounted() {
    miniToastr.init();
  },

  notifications: {
    showLoginError: {
      title: 'Error',
      message: 'Hello from nuxt.js',
      type: 'error'
    },
    showSuccess: {
      title: 'Success',
      message: '',
      type: 'success'
    }
  },
  asyncData: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var store = _ref.store,
          query = _ref.query,
          error = _ref.error;
      var userData, listRevise, result, quData;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              userData = store.state.authUser;

              if (userData.isAdmin) {
                _context.next = 3;
                break;
              }

              return _context.abrupt('return', error({ statusCode: 401, message: 'Permision Denied' }));

            case 3:
              _context.next = 5;
              return API.setToken(userData.tokenID);

            case 5:
              _context.next = 7;
              return API.GetRevise(query.quNo);

            case 7:
              listRevise = _context.sent;
              _context.next = 10;
              return API.GetDataFromRevise(query.quNo, query.revise);

            case 10:
              result = _context.sent;
              quData = result.data.datas;

              //
              // // let value1 = await reloadData(query.projectID)
              // let listTask = value1.data.datas

              return _context.abrupt('return', {
                dataID: query.quNo,
                projectID: query.projectID,
                userData: userData,
                quData: quData,
                copyFrom: query.revise,
                listRevise: listRevise.data.datas
              });

            case 13:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function asyncData(_x) {
      return _ref2.apply(this, arguments);
    }

    return asyncData;
  }(),
  data: function data() {
    return {
      quData: {
        leadTime: '',
        projectID: '',
        amount: 0,
        copyFrom: 0,
        quNo: '',
        quotationFile: '',
        planiningSheet: '',
        quotationTask: []
      },
      taskDetail: {
        taskName: '',
        taskDetail: '',
        estStartDate: '',
        estFinishDate: ''
      },
      isActiveDropdown: 'dropdown is-right'
    };
  },

  methods: {
    deleteTask: function deleteTask(index) {
      this.quData.quotationTask.splice(index, 1);
    },
    copy: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(revise) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function copy(_x2) {
        return _ref3.apply(this, arguments);
      }

      return copy;
    }(),
    activeDropdown: function activeDropdown() {
      if (this.isActiveDropdown === 'dropdown is-right') {
        this.isActiveDropdown = 'dropdown is-active is-right';
      } else {
        this.isActiveDropdown = 'dropdown is-right';
      }
    },

    addTaskConfig: function addTaskConfig() {
      if (this.taskDetail.taskName === '') {
        this.showLoginError({ message: 'Please Insert TaskName' });
        return false;
      }
      if (this.taskDetail.estStartDate === '') {
        this.showLoginError({ message: 'Please Select EstStartDate' });
        return false;
      }
      if (this.taskDetail.estFinishDate === '') {
        this.showLoginError({ message: 'Please Select EstFinishDate' });
        return false;
      }
      this.quData.quotationTask.push({
        taskName: this.taskDetail.taskName,
        taskDetail: this.taskDetail.taskDetail,
        estStartDate: this.taskDetail.estStartDate,
        estFinishDate: this.taskDetail.estFinishDate
      });
    },
    createQutation: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var items, formData, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, file, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, pro, result;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return API.setToken(this.userData.tokenID);

              case 2:

                this.quData.quNo = this.dataID;
                this.quData.projectID = this.projectID;

                items = this.$refs.upload.getItems();
                formData = new FormData(); // Currently empty

                formData.append('projectID', this.projectID);
                formData.append('quRef', this.quData.quRef);
                formData.append('leadTime', this.quData.leadTime);
                formData.append('quotationDetail', '');
                formData.append('amount', this.quData.amount);
                formData.append('quNo', this.quData.quNo);

                formData.append('revise', this.quData.revise);
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context3.prev = 16;
                for (_iterator = _getIterator(items); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  file = _step.value;

                  formData.append('quFile', file.file, file.file.name);
                }
                _context3.next = 24;
                break;

              case 20:
                _context3.prev = 20;
                _context3.t0 = _context3['catch'](16);
                _didIteratorError = true;
                _iteratorError = _context3.t0;

              case 24:
                _context3.prev = 24;
                _context3.prev = 25;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 27:
                _context3.prev = 27;

                if (!_didIteratorError) {
                  _context3.next = 30;
                  break;
                }

                throw _iteratorError;

              case 30:
                return _context3.finish(27);

              case 31:
                return _context3.finish(24);

              case 32:
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context3.prev = 35;
                for (_iterator2 = _getIterator(this.quData.quotationTask); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  pro = _step2.value;

                  formData.append('taskName', pro.taskName);
                  formData.append('estStartDate', pro.estStartDate);
                  formData.append('estFinishDate', pro.estFinishDate);
                  // formData.append('taskDetail', pro.taskDetail)
                  // ต้องใช้ Task detail 2 ก่อน ไม่รู้ทำไม
                  formData.append('taskDetail2', pro.taskDetail);
                }

                _context3.next = 43;
                break;

              case 39:
                _context3.prev = 39;
                _context3.t1 = _context3['catch'](35);
                _didIteratorError2 = true;
                _iteratorError2 = _context3.t1;

              case 43:
                _context3.prev = 43;
                _context3.prev = 44;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 46:
                _context3.prev = 46;

                if (!_didIteratorError2) {
                  _context3.next = 49;
                  break;
                }

                throw _iteratorError2;

              case 49:
                return _context3.finish(46);

              case 50:
                return _context3.finish(43);

              case 51:
                _context3.next = 53;
                return API.CreateNewQUFromRevise(formData, this.quData.projectID, this.quData.quNo, this.quData.revise);

              case 53:
                result = _context3.sent;

                if (result.data.flag) {
                  this.showSuccess({
                    message: 'Already Create QU:' + ' ' + result.data.datas.quNo + ', Revise:' + result.data.datas.revise
                  });
                  window.location.href = '/project/' + this.projectID;
                  this.$refs.isBtn.enabled();
                } else {
                  this.$refs.btnCreate.enabled();
                  this.showLoginError({ message: result.data.message });
                  this.$refs.isBtn.enabled();
                }

              case 55:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[16, 20, 24, 32], [25,, 27, 31], [35, 39, 43, 51], [44,, 46, 50]]);
      }));

      function createQutation() {
        return _ref4.apply(this, arguments);
      }

      return createQutation;
    }()
  },
  components: {
    Datepicker: Datepicker,
    grantchart: grantchart,
    upload: upload,
    isButton: isButton
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/project/quotation/create-revise.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/project/quotation/create-revise.vue
// module chunks = 31